import { render, staticRenderFns } from "./WelcomePanels.html?vue&type=template&id=4ee31658&external"
import script from "./WelcomePanels.js?vue&type=script&lang=js&external"
export * from "./WelcomePanels.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports